// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__2yL8A","containerItemsCenter":"Skeleton_containerItemsCenter__aRbtt"};